"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillLfmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillLfmlFilled = function MealVkusvillLfmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.335 18.162h-6.373l2.406-10.534c.106-.28.106-.587 0-.867a1.355 1.355 0 00-.772-.606 1.632 1.632 0 00-1.023-.121 1.573 1.573 0 00-.718.537L11.149 20.917a.613.613 0 00-.083.674.633.633 0 00.249.26c.107.062.23.092.355.088h6.355L15.62 32.473c-.074.286-.036.589.107.85.153.261.385.473.665.605.303.096.63.096.933 0 .328-.028.634-.17.862-.398l11.67-14.363a.63.63 0 00.077-.678.65.65 0 00-.245-.264.68.68 0 00-.354-.098",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillLfmlFilled = MealVkusvillLfmlFilled;
var _default = MealVkusvillLfmlFilled;
exports.default = _default;